import { render, staticRenderFns } from "./examResult.vue?vue&type=template&id=486222b0&scoped=true"
import script from "./examResult.vue?vue&type=script&lang=js"
export * from "./examResult.vue?vue&type=script&lang=js"
import style0 from "./examResult.vue?vue&type=style&index=0&id=486222b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486222b0",
  null
  
)

export default component.exports